import type { ServerResponse } from "@/http"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"

interface GenerateQRCodeFields {
  format: "jpg" | "png" | "svg"
  useTransparentBackground?: boolean
  foregroundColor?: string
  backgroundColor?: string
}

interface UseGenerateQRCodeParams {
  eventVaultId: number
  fields: GenerateQRCodeFields
}

export async function generateQRCode(eventVaultId: number, fields: GenerateQRCodeFields): Promise<string> {
  const endpoint = `/api/event/${eventVaultId}/qr/customize`
  const response = await axios.post<ServerResponse<{ FileName: string, DownloadUrl: string }>>(endpoint, fields)

  return response.data.Data?.DownloadUrl ?? ""
}

export function useGenerateQRCode() {
  return useMutation({
    mutationFn: ({ eventVaultId, fields }: UseGenerateQRCodeParams) => generateQRCode(eventVaultId, fields),
  })
}
